import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { ROUTE_DRIVER_JOB, ROUTE_DRIVER_JOB_APPLY, ROUTE_DRIVER_JOB_COMPLETED, ROUTE_DRIVER_JOB_LANDING_PAGE, ROUTE_DRIVER_JOB_REJECTED, ROUTE_DRIVER_JOB_SIGN_IN, ROUTE_DRIVER_JOB_SIGN_UP, ROUTE_DRIVER_JOB_SIGNUP_COMPLETED, ROUTE_DRIVER_JOB_SIGNUP_ERROR, ROUTE_DRIVER_JOB_SIGNUP_SUCCESS, ROUTE_DRIVER_JOB_ONBOARDING_WELCOME, ROUTE_DRIVER_JOB_ONBOARDING_ACCOUNT, ROUTE_DRIVER_JOB_ONBOARDING_PROFILE, ROUTE_DRIVER_JOB_ONBOARDING_APPLY } from './shared/routes';
import { SignUpCompletedComponent } from './sign-up-completed/sign-up-completed.component';
import { SignupSuccessComponent } from './signup-success/signup-success.component';
import { SignUpErrorComponent } from './sign-up-error/sign-up-error.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { DriverGuardService } from '../core/guards/driver-guard.service';
import { JobApplyComponent } from './job-apply/job-apply.component';
import { JobCompletedComponent } from './job-completed/job-completed.component';
import { JobRejectedComponent } from './job-rejected/job-rejected.component';
import { OnboardingWelcomeComponent } from './onboarding/onboarding-welcome/onboarding-welcome.component';
import { OnboardingAccountComponent } from './onboarding/onboarding-account/onboarding-account.component';
import { OnboardingProfileComponent } from './onboarding/onboarding-profile/onboarding-profile.component';
import { OnboardingApplyComponent } from './onboarding/onboarding-apply/onboarding-apply.component';

export const routes: Routes = [
  { path: ROUTE_DRIVER_JOB_LANDING_PAGE, component: LandingPageComponent },
  { path: ROUTE_DRIVER_JOB_SIGN_UP, component: SignUpComponent },
  { path: ROUTE_DRIVER_JOB_SIGN_IN, component: SignInComponent },
  { path: ROUTE_DRIVER_JOB_SIGNUP_COMPLETED, component: SignUpCompletedComponent },
  { path: ROUTE_DRIVER_JOB_SIGNUP_SUCCESS, component: SignupSuccessComponent },
  { path: ROUTE_DRIVER_JOB_SIGNUP_ERROR, component: SignUpErrorComponent },
  { path: ROUTE_DRIVER_JOB_APPLY, component: JobApplyComponent, canActivate: [DriverGuardService] },
  { path: ROUTE_DRIVER_JOB_COMPLETED, component: JobCompletedComponent, canActivate: [DriverGuardService] },
  { path: ROUTE_DRIVER_JOB_REJECTED, component: JobRejectedComponent },
  // Onboarding routes
  { path: ROUTE_DRIVER_JOB_ONBOARDING_WELCOME, component: OnboardingWelcomeComponent },
  { path: ROUTE_DRIVER_JOB_ONBOARDING_ACCOUNT, component: OnboardingAccountComponent },
  { path: ROUTE_DRIVER_JOB_ONBOARDING_PROFILE, component: OnboardingProfileComponent },
  { path: ROUTE_DRIVER_JOB_ONBOARDING_APPLY, component: OnboardingApplyComponent },
  { path: '', redirectTo: ROUTE_DRIVER_JOB_ONBOARDING_WELCOME, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DriverJobRoutingModule { }
